import { CenterAlignIcon, LeftAlignIcon, RightAlignIcon } from 'assets/icons/common'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { startCase } from 'lodash'
import React from 'react'
import styles from './AlignmentDropdown.module.scss'

interface Alignment {
  icon: typeof LeftAlignIcon
  horizontalAlign: 'left' | 'center' | 'right'
}

const alignments: Array<Alignment> = [
  {
    icon: LeftAlignIcon,
    horizontalAlign: 'left',
  },
  {
    icon: CenterAlignIcon,
    horizontalAlign: 'center',
  },
  {
    icon: RightAlignIcon,
    horizontalAlign: 'right',
  },
]

export type AlignmentDropdownProps = {
  onPick: (picked: Alignment['horizontalAlign']) => void
  activeAlignment: Alignment['horizontalAlign']
}

export const AlignmentDropdown: React.FC<React.PropsWithChildren<AlignmentDropdownProps>> = (props) => {
  return (
    <div className={styles.AlignmentDropdown}>
      {alignments.map((alignment) => (
        <InlineFormatDropdownMenuItem
          key={alignment.horizontalAlign}
          icon={<alignment.icon />}
          label={`${startCase(alignment.horizontalAlign)} align`}
          onClick={() => props.onPick(alignment.horizontalAlign)}
          active={props.activeAlignment === alignment.horizontalAlign}
        />
      ))}
    </div>
  )
}
